import { render, staticRenderFns } from "./u-btn-icon-flat-rounded.vue?vue&type=template&id=b53204f6&scoped=true"
import script from "./u-btn-icon-flat-rounded.vue?vue&type=script&lang=js"
export * from "./u-btn-icon-flat-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53204f6",
  null
  
)

export default component.exports